import { userGet } from "./userActions";
import Notify from "./notifyActions";
export const DEVICE_SOFTWARE_LIST = "DEVICE_SOFTWARE_LIST";

export const deviceSoftwareList = (pager, software) => ({
  type: DEVICE_SOFTWARE_LIST,
  payload: {
    request: {
      mode: "no-cors",
      url: "device-software-releases",
      method: "POST",
      data: pager,
      software
    }
  }
});

export const DEVICE_SOFTWARE_GET = "DEVICE_SOFTWARE_GET";

export const getDeviceSoftware = id => ({
  type: DEVICE_SOFTWARE_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `device-software-release/${id}`,
      method: "GET"
    }
  }
});

export const MINIMUM_VERSIONS_GET = "MINIMUM_VERSIONS_GET";

export const getMinimumVersions = () => ({
  type: MINIMUM_VERSIONS_GET,
  payload: {
    request: {
      mode: "no-cors",
      url: `device-software/minimum-versions`,
      method: "GET"
    }
  }
});

export const DEVICE_SOFTWARE_CREATE = "DEVICE_SOFTWARE_CREATE";
export const DEVICE_SOFTWARE_CREATE_SUCCESSFULL_TOAST = "device_software_create_successfull_toast";

export const deviceSoftwareCreate = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DEVICE_SOFTWARE_CREATE,
        payload: {
          request: {
            mode: "no-cors",
            url: "device-software-release",
            method: "POST", 
            data: { 
              deviceupdaterepositoryname: data.deviceupdaterepositoryname, 
              systemdevicetypename: data.systemdevicetypename, 
              version: data.version, 
              minimumsystemversion: data.minimumsystemversion, 
              isfullsystemupdate: data.isfullsystemupdate
            }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
           dispatch(Notify.success(DEVICE_SOFTWARE_CREATE_SUCCESSFULL_TOAST));
           dispatch(getMinimumVersions());
          if (pager) {
            dispatch(deviceSoftwareList(pager));
          }
          resolve();
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const DEVICE_SOFTWARE_UPDATE = "DEVICE_SOFTWARE_UPDATE";
export const DEVICE_SOFTWARE_UPDATE_SUCCESSFULL_TOAST = "device_software_update_successfull_toast";

export const deviceSoftwareUpdate = (data, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DEVICE_SOFTWARE_UPDATE,
        payload: {
          request: {
            mode: "no-cors",
            url: "device-software-release",
            method: "PUT",
            data: { 
              id: data.id,
              deviceupdaterepositoryname: data.deviceupdaterepositoryname, 
              systemdevicetypename: data.systemdevicetypename, 
              version: data.version, 
              minimumsystemversion: data.minimumsystemversion, 
              isfullsystemupdate: data.isfullsystemupdate
            }
          }
        }
      }).then(response => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
            dispatch(Notify.success(DEVICE_SOFTWARE_UPDATE_SUCCESSFULL_TOAST));
          
          dispatch(deviceSoftwareSelect(data.id));
          dispatch(getMinimumVersions());
          if (pager) {
            dispatch(deviceSoftwareList(pager));
          }
          let state = getState();
          if (state.userReducer.user && state.userReducer.user.Default && state.userReducer.user.id) {
            dispatch(userGet(state.userReducer.user.id));
          }
          resolve();
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const DEVICE_SOFTWARE_CREATE_RESET = "DEVICE_SOFTWARE_CREATE_RESET";

export const deviceSoftwareCreateReset = () => ({
  type: DEVICE_SOFTWARE_CREATE_RESET
});

export const DEVICE_SOFTWARE_SELECTED = "DEVICE_SOFTWARE_SELECTED";
export const deviceSoftwareSelect = cid => {
  return (dispatch, getState) => {
    dispatch({
      type: DEVICE_SOFTWARE_SELECTED,
      payload: {
        request: {
          mode: "no-cors",
          url: `device-software-release/${cid}`,
          method: "GET"
        }
      }
    }).then(response => {
      const software = response.payload.data;
      dispatch(deviceSoftwareLoaded(software));
    });
  };
};

export const DEVICE_SOFTWARE_LOADED = "DEVICE_SOFTWARE_LOADED";
export const deviceSoftwareLoaded = software => ({
  type: DEVICE_SOFTWARE_LOADED,
  data: {
    software
  }
});

export const DEVICE_SOFTWARE_DELETE = "DEVICE_SOFTWARE_DELETE";
export const DEVICE_SOFTWARE_DELETE_SUCCESSFULL_TOAST = "device_software_delete_successfull_toast";
export const DEVICE_SOFTWARE_DELETE_FAIL_TOAST = "device_software_delete_fail_toast";

export const deviceSoftwareDelete = (id, pager) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DEVICE_SOFTWARE_DELETE,
        payload: {
          request: {
            mode: "no-cors",
            url: `device-software-release/${id}`,
            method: "DELETE"
          }
        }
      }).then(response => {
        if (response.type == "DEVICE_SOFTWARE_DELETE_FAIL_TOAST") {
          dispatch(Notify.error(DEVICE_SOFTWARE_DELETE_FAIL_TOAST));
        } else {
          dispatch(Notify.success(DEVICE_SOFTWARE_DELETE_SUCCESSFULL_TOAST));
        }
        resolve(true);
        if (pager) {
          dispatch(deviceSoftwareList(pager));
        }
      });
    });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/deviceSoftwareActions.js